import styles from './image-view.module.scss';
import { getPortraitHeightByWidth, ImageTypes, setImageStyles } from '../image-gallery.utils';

const ImageViewComponent = (props) => { // TODO-A Put the correct model
  const {
    width,
    aspectType = ImageTypes.PORTRAIT,
    image
  } = props;

  const height = aspectType === ImageTypes.SQUARE
    ? width
    : getPortraitHeightByWidth(width);

  const handleImageVideoUrl = (url: string): boolean => {
      if (!url) return true;
      return (url.includes('video/mp4') || url.includes('.mp4')) ? false : true;
  };

  return (
    <>
    {handleImageVideoUrl(image.url) ? (
    <div
      className={styles.container}
      style={setImageStyles({ width, height }, image, aspectType)}
    />
    ) : (
      <>
        <video width={width} height={height}>
          <source src={image.url} />
        </video>
        <div className={styles.playButton}>▶</div>
      </>
    )}
    </>
  );
};

const ImageView = ImageViewComponent;
export { ImageView };
